import { useWidget, WidgetToolbar, WidgetBase, ReadOnlyWidgetBase, TransparentImg, WidgetBaseProp } from 'widgets/sdk';
import QRCode from 'qrcode.react';
import { QRCodeWidgetData } from './QRCodeWidget.types';
import { QRCodeWidgetToolbarMenu } from './QRCodeWidgetToolbar';

export const QRCodeWidget = () => {
  return (
    <WidgetBase>
      <WidgetToolbar>
        <QRCodeWidgetToolbarMenu />
      </WidgetToolbar>
      <QRCodeBase />
    </WidgetBase>
  );
};

const QRCodeBase = () => {
  const { url, backgroundColor, foreGroundColor } = useWidget<QRCodeWidgetData>();

  return (
    <QRCode bgColor={backgroundColor} fgColor={foreGroundColor} width='100%' height='100%' value={url} renderAs='svg' />
  );
};

export const ReadOnlyQRCodeWidget = ({ includeAltTextImg }: WidgetBaseProp) => {
  return (
    <ReadOnlyWidgetBase>
      <QRCodeBase />
      {includeAltTextImg && <TransparentImg />}
    </ReadOnlyWidgetBase>
  );
};
